import swipe from "../assets/audio/swipe.wav";
import squeak from "../assets/audio/squeak.wav";
import theme from "../assets/audio/theme.mp3";
import grind from "../assets/audio/grind.wav";

const sounds = {
  swipe,
  squeak,
  theme,
  grind,
};

type SoundKey = keyof typeof sounds;
type AudioChannel = keyof typeof volumes;
type GameSound = Omit<HTMLAudioElement, "play">;

export const volumes = {
  MUSIC: 1,
  GAME: 1,
};

const preloadSound = (src: string) =>
  new Promise((resolve, reject) => {
    try {
      const audio = new Audio(src);
      audio.addEventListener("canplaythrough", () => {
        resolve(audio);
      });
    } catch {
      reject();
    }
  });

export const preloadAudio = async () => {
  return Promise.all(
    Object.values(sounds).map(async (s) => {
      preloadSound(s);
    }),
  );
};

export const loadSound = (key: SoundKey): GameSound => {
  return new Audio(sounds[key]);
};

export const playSound = (sound: GameSound, channel: AudioChannel) => {
  sound.volume *= volumes[channel];
  return (sound as HTMLAudioElement).play();
};
